/** Sayt matnlari — o'zbekcha (lotin). Ruscha keyinroq shu yerga qo'shiladi. */
export const uz = {
  brand: "Hovli Liga",
  tagline: "Havaskor futbol uchun",

  nav: {
    home: "Bosh sahifa",
    posts: "E'lonlar",
    winners: "G'oliblar",
    open: "Botni ochish",
  },

  hero: {
    eyebrow: "Telegram ichida ishlaydi",
    title: "O'yin yig'ish — guruhdagi chalkashliksiz",
    lead:
      "Kapitan o'yin e'lon qiladi, guruhdagilar bitta tugma bilan javob beradi. " +
      "Kim kelishi, nechta o'rin qolgani va jamoalar — hammasi bir joyda.",
    cta: "Telegramda ochish",
    secondary: "Qanday ishlaydi",
    note: "Ro'yxatdan o'tish shart emas — Telegram hisobingiz yetarli.",
  },

  /** Hero'dagi namunaviy o'yin kartochkasi. */
  card: {
    when: "Juma, 2-oktabr · 19:00",
    venue: "Mahalla maydoni",
    meta: "Shayxontohur · 5x5 · kishi boshiga 21 000 so'm",
    need: "Yana 2 kishi kerak",
    join: "Kelaman",
    decline: "Kelmayman",
    roster: "Keladi",
  },

  problems: {
    title: "Nimani hal qiladi",
    items: [
      {
        title: "«Kim keladi?» so'rovi yo'qoladi",
        text:
          "Guruhda yozilgan ismlar boshqa xabarlar orasida ko'milib ketadi. " +
          "Ilovada ro'yxat doim tepada va o'zi yangilanadi.",
      },
      {
        title: "O'yinga bir-ikki odam yetmaydi",
        text:
          "Nechta o'rin bo'shligi kartochkada ko'rinib turadi. " +
          "O'rin bo'shasa, zaxiradagi birinchi odam avtomatik ko'tariladi.",
      },
      {
        title: "Yozilgan odam kelmay qoladi",
        text:
          "Har bir o'yinchining ishonchlilik bali bor. Kelmaganda ball tushadi, " +
          "o'ynaganda tiklanadi — kapitan kimni chaqirayotganini biladi.",
      },
    ],
  },

  steps: {
    title: "Qanday ishlaydi",
    items: [
      {
        title: "O'yin yarating",
        text: "Sana, maydon, format va nechta o'rin. Bir daqiqada tayyor.",
      },
      {
        title: "Guruhga ulashing",
        text:
          "Kartochka guruhga tushadi. Botni guruhga qo'shish shart emas — " +
          "javoblar kartochkada o'zi yangilanadi.",
      },
      {
        title: "Jamoalarga bo'ling",
        text:
          "Kelganlar aniq bo'lgach, ilova kuchlari teng jamoalarga bo'ladi " +
          "va natijani guruhga e'lon qiladi.",
      },
    ],
  },

  reliability: {
    title: "Ishonchlilik bali",
    lead: "Hamma 100 balldan boshlaydi. Ball e'londa ham, profilda ham ko'rinadi.",
    rows: [
      { label: "Yozilib kelmaslik", value: "−20" },
      { label: "O'yinga 3 soatdan kam qolganda chiqish", value: "−10" },
      { label: "Har bir o'tkazilgan o'yin", value: "+2" },
    ],
  },

  posts: {
    title: "E'lonlar",
    lead: "Mavsum yangiliklari, qoidalar o'zgarishi va ilovaga qo'shilgan imkoniyatlar.",
    empty: "Hozircha e'lon yo'q.",
    readMore: "To'liq o'qish",
    back: "Barcha e'lonlar",
  },

  winners: {
    title: "G'oliblar",
    lead: "Mavsum yakunida eng yuqori reytingni yig'gan jamoalar.",
    empty: "Birinchi mavsum hali yakunlanmagan.",
    columns: {
      place: "O'rin",
      team: "Jamoa",
      district: "Tuman",
      captain: "Kapitan",
      played: "O'yin",
      won: "G'alaba",
      rating: "Reyting",
    },
  },

  sample: {
    notice: "Namunaviy ma'lumot — haqiqiy e'lonlar mavsum boshlanishi bilan chiqadi.",
  },

  footer: {
    rights: "Havaskor futbolchilar uchun ochiq loyiha.",
    bot: "Telegram bot",
    contact: "Aloqa",
  },
} as const;
